import { COMPANY_URL } from '@/modules/company/company.constants';
import { resolveCurrentUser } from '@/modules/user/user.service';
import { createEmptyComponent } from '@/router/route.service';

export default [
  {
    path: COMPANY_URL.path,
    redirect: '/',
    beforeEnter: resolveCurrentUser,
    component: { render: createEmptyComponent },
    children: [
      {
        ...COMPANY_URL.edit,
        component: () => import('@/modules/company/views/CompanyEditPage.vue'),
      },
      {
        ...COMPANY_URL.analytics,
        component: () => import('@/modules/company/views/CompanyAnalytics.vue'),
      },
    ],
  },
];

export function goToEditCompany($router) {
  $router.push({
    name: COMPANY_URL.edit.name,
  });
}
